import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Alert } from 'reactstrap';
import Grid from '../grid/Grid';
import { getEditIconColumn } from '../grid/ColumnHelpers';
import Loading from '../Loading';
import NavGeometrijaBridinajums from './NavGeometrijaBridinajums';
import { getRiskLevel, getStatusBadgeColor } from './riskaNovertejumsUtils';
import {
    loadRiskaNovertejumiList,
    createJaunsRiskaNovertejums
} from '../../actions/dzeramaUdensSatecesBaseiniActions';

const safeDateFormatter = (cell) => {
    if (!cell) return '';
    try {
        const date = new Date(cell);
        if (isNaN(date.getTime())) return '';
        return date.toLocaleDateString('lv-LV');
    } catch (e) {
        return '';
    }
};

const riskLevelFormatter = (cell) => {
    const risk = getRiskLevel(cell);
    if (!risk.color) return '';
    return risk.label;
};

const riskLevelStyle = (cell) => {
    const risk = getRiskLevel(cell);
    if (!risk.color) return {};
    return {
        backgroundColor: risk.color,
        fontWeight: '500'
    };
};

class DzeramaUdensSatecesBaseinsRiskaNovertejums extends Component {

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.loadData();
        }
    }

    loadData = () => {
        const { dispatch, id } = this.props;
        if (id) {
            dispatch(loadRiskaNovertejumiList(id));
        }
    }

    handleCreateNew = async () => {
        const { dispatch, id } = this.props;

        if (this.state && this.state.creating) {
            return;
        }

        this.setState({ creating: true, error: null });

        try {
            await dispatch(createJaunsRiskaNovertejums(id));
            await this.loadData();
            this.setState({ creating: false });
        } catch (error) {
            console.error('Error creating risk assessment:', error);
            this.setState({
                creating: false,
                error: error.message || 'Kļūda izveidojot riska novērtējumu'
            });
        }
    }

    getStatusBadge = (statuss) => {
        return `badge badge-${getStatusBadgeColor(statuss)}`;
    }

    getColumns = () => {
        const editIconColumn = getEditIconColumn((row) => ({
            type: 'loc_riska_novertejums_detalizeti',
            payload: {
                dzusb_id: this.props.id,
                id: row.id
            }
        }));

        return [
            editIconColumn,
            {
                dataField: 'nosaukums',
                text: 'Nosaukums',
                sort: true
            },
            {
                dataField: 'maksimalais_risks',
                text: 'Riska novērtējums',
                sort: true,
                formatter: riskLevelFormatter,
                style: riskLevelStyle
            },
            {
                dataField: 'izveidots',
                text: 'Izveides datums',
                sort: true,
                formatter: safeDateFormatter
            },
            {
                dataField: 'datums',
                text: 'Apstiprināšanas datums',
                sort: true,
                formatter: (cell) => cell ? safeDateFormatter(cell) : '-'
            },
            {
                dataField: 'statuss',
                text: 'Statuss',
                sort: true,
                formatter: (cell) => (
                    <span className={this.getStatusBadge(cell)}>
                        {cell}
                    </span>
                )
            },
            {
                dataField: 'autors',
                text: 'Autors',
                sort: true
            }
        ];
    }

    render() {
        const { data, loading, error, hasGeometry, isArhivets } = this.props;
        const creating = this.state && this.state.creating;
        const createError = this.state && this.state.error;

        if (loading) {
            return <Loading />;
        }

        if (error) {
            return <Alert color="danger">Kļūda ielādējot datus: {error}</Alert>;
        }

        // Check if basin has geometry
        if (!hasGeometry) {
            return <NavGeometrijaBridinajums title="Riska novērtējums" />;
        }

        return (
            <>
                {createError && (
                    <Alert color="danger" className="mb-3">
                        {createError}
                    </Alert>
                )}

                <div className="saraksts-wrapper">
                    <Grid
                        dataList={data || []}
                        totalCount={data ? data.length : 0}
                        columns={this.getColumns()}
                        enablePaging={false}
                        exportViewname="riska_novertejumi_list"
                        exportQuery={{ dzusb_id: this.props.id }}
                        extraGridProps={{ rowClasses: (row) => row.statuss === 'arhivēts' ? 'row-archived' : '' }}
                    >
                        {!isArhivets && this.props.user?.tiesibas?.includes('SATECES_BASEINI_VERTETAJS') && (
                            <Button
                                color="success"
                                onClick={this.handleCreateNew}
                                disabled={loading || creating}
                            >
                                {creating ? 'Izveido...' : '+ Jauns novērtējums'}
                            </Button>
                        )}
                    </Grid>
                </div>

                <div className="mt-3">
                    <small className="text-muted">
                        * Riska novērtējumi jāveic reizi sešos gados saskaņā ar normatīvajiem aktiem
                    </small>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const riskaNovertejumi = state.riskaNovertejumi || {};
    const baseins = state.dzeramaUdensSatecesBaseins;

    const hasGeometry = baseins.selectedItem && (
        (baseins.selectedItem.sb_geom) ||
        (baseins.selectedItem.urbumi_atradnes_geom_id)
    );

    return {
        data: riskaNovertejumi.list || [],
        loading: riskaNovertejumi.loading || false,
        error: riskaNovertejumi.error,
        hasGeometry,
        isArhivets: !!(baseins.selectedItem && baseins.selectedItem.ir_arhivets),
        user: state.user || {}
    };
};

export default connect(mapStateToProps)(DzeramaUdensSatecesBaseinsRiskaNovertejums);